export const ValidationMessages = {
    isRequired: "Kérjük töltse ki a mezőt!",
    isBeforeOrSameDate: "Kérem a jelenlegi dátum utáni időpontot adjon meg!",
    minLength: (min: number) => `Kérjük adjon meg minimum ${min} karaktert!`,
    minValue: (min: number) => `Az érték nem lehet kisebb mint ${min}!`,
    maxValue: (max: number) => `Az érték nem lehet nagyobb mint ${max}!`,
    invalidEmailMessage: "Érvénytelen e-mail cím!",
};